import { render, staticRenderFns } from "./ModalTemporada.vue?vue&type=template&id=72c71180&"
import script from "./ModalTemporada.vue?vue&type=script&lang=js&"
export * from "./ModalTemporada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports